import { debounce } from '@/components/Tour/utils/tour';
import { DESIGN_WIDTH } from '@/utils/constant';
import { checkIsMobile } from './common';

/** PC web 应用简单适配移动端宽度 */
const adaptiveViewport = () => {
  /** 获取已存在的 meta viewport 标签 */
  const metaViewport = document.querySelector('meta[name="viewport"]');
  /** 移动端进行设置 */
  if (checkIsMobile()) {
    const deviceWidth = window.screen.width || document.documentElement.clientWidth;
    const scale = deviceWidth / DESIGN_WIDTH;
    if (metaViewport) {
      metaViewport.setAttribute('content', `width=device-width, initial-scale=${scale}`);
    }
  } else {
    /** PC 端恢复默认配置为 1 */
    if (metaViewport) {
      metaViewport.setAttribute('content', 'width=device-width, initial-scale=1');
    }
  }
}

/** 初始化移动端适配逻辑 */
const initAdaptMobile = () => {
  // 监听窗口大小变化
  window.addEventListener('resize', debounce(adaptiveViewport));
  // 初始化执行一次
  adaptiveViewport();
}

export {
  initAdaptMobile
};